import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=e7f3287c&scoped=true&"
import script from "./UpdateNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateNotification.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=e7f3287c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f3287c",
  null
  
)

export default component.exports